export const DEFAULT_COORDINATES = {
  // 28 States
  'Andhra Pradesh': [79.7400, 15.9129],
  'Arunachal Pradesh': [94.7278, 28.2180],
  'Assam': [92.9376, 26.2006],
  'Bihar': [85.3131, 25.0961],
  'Chhattisgarh': [81.8661, 21.2787],
  'Goa': [74.1240, 15.2993],
  'Gujarat': [71.1924, 22.2587],
  'Haryana': [76.0856, 29.0588],
  'Himachal Pradesh': [77.1734, 31.1048],
  'Jharkhand': [85.2799, 23.6102],
  'Karnataka': [75.7139, 15.3173],
  'Kerala': [76.2711, 10.8505],
  'Madhya Pradesh': [78.6569, 22.9734],
  'Maharashtra': [75.7139, 19.7515],
  'Manipur': [93.9063, 24.6637],
  'Meghalaya': [91.3662, 25.4670],
  'Mizoram': [92.9376, 23.1645],
  'Nagaland': [94.5624, 26.1584],
  'Odisha': [85.0985, 20.9517],
  'Punjab': [75.3412, 31.1471],
  'Rajasthan': [74.2179, 27.0238],
  'Sikkim': [88.5122, 27.5330],
  'Tamil Nadu': [78.6569, 11.1271],
  'Telangana': [79.0193, 17.1232],
  'Tripura': [91.9882, 23.9408],
  'Uttar Pradesh': [80.9462, 26.8467],
  'Uttarakhand': [79.0193, 30.0668],
  'West Bengal': [87.8550, 22.9868],

  // 8 Union Territories
  'Andaman and Nicobar Islands': [92.6586, 11.7401],
  'Chandigarh': [76.7794, 30.7333],
  'Dadra and Nagar Haveli and Daman and Diu': [73.0169, 20.1809],
  'Daman and Diu': [72.8397, 20.4283],
  'Delhi': [77.1025, 28.7041],
  'Jammu and Kashmir': [76.9366, 33.7782],
  'Ladakh': [77.5771, 34.1526],
  'Lakshadweep': [72.6358, 10.5667],
  'Puducherry': [79.8083, 11.9416],

  // Alternate spellings and old names
  'Pondicherry': [79.8083, 11.9416],
  'Orissa': [85.0985, 20.9517],
  'Uttaranchal': [79.0193, 30.0668],
  'Jammu & Kashmir': [76.9366, 33.7782],
  'J&K': [76.9366, 33.7782],

  // Major cities
  'Mumbai': [72.8777, 19.0760],
  'Delhi City': [77.1025, 28.7041],
  'Bangalore': [77.5946, 12.9716],
  'Bengaluru': [77.5946, 12.9716],
  'Hyderabad': [78.4867, 17.3850],
  'Ahmedabad': [72.5714, 23.0225],
  'Chennai': [80.2707, 13.0827],
  'Kolkata': [88.3639, 22.5726],
  'Surat': [72.8311, 21.1702],
  'Pune': [73.8567, 18.5204],
  'Jaipur': [75.7873, 26.9124],
  'Lucknow': [80.9462, 26.8467],
  'Kanpur': [80.3319, 26.4499],
  'Nagpur': [79.0882, 21.1458],
  'Indore': [75.8333, 22.7196],
  'Thane': [72.9780, 19.2183],
  'Bhopal': [77.4126, 23.2599],
  'Visakhapatnam': [83.2185, 17.6868],
  'Pimpri-Chinchwad': [73.8314, 18.6279],
  'Patna': [85.1376, 25.5941],
  'Vadodara': [73.1812, 22.3072],
  'Baroda': [73.1812, 22.3072],
  'Ghaziabad': [77.4538, 28.6692],
  'Ludhiana': [75.8573, 30.9010],
  'Agra': [78.0081, 27.1767],
  'Nashik': [73.7898, 19.9975],
  'Faridabad': [77.3178, 28.4089],
  'Meerut': [77.7064, 28.9845],
  'Rajkot': [70.8022, 22.3039],
  'Kalyan-Dombivli': [73.1305, 19.2403],
  'Vasai-Virar': [72.8397, 19.4259],
  'Varanasi': [82.9739, 25.3176],
  'Srinagar': [74.7973, 34.0837],
  'Aurangabad': [75.3433, 19.8762],
  'Dhanbad': [86.4304, 23.7957],
  'Amritsar': [74.8723, 31.6340],
  'Navi Mumbai': [73.0297, 19.0330],
  'Allahabad': [81.8463, 25.4358],
  'Prayagraj': [81.8463, 25.4358],
  'Ranchi': [85.3096, 23.3441],
  'Howrah': [88.2636, 22.5958],
  'Coimbatore': [76.9558, 11.0168],
  'Jabalpur': [79.9864, 23.1815],
  'Gwalior': [78.1828, 26.2183],
  'Vijayawada': [80.6480, 16.5062],
  'Jodhpur': [73.0243, 26.2389],
  'Madurai': [78.1198, 9.9252],
  'Raipur': [81.6296, 21.2514],
  'Kota': [75.8648, 25.2138],
  'Chandigarh City': [76.7794, 30.7333],
  'Guwahati': [91.7362, 26.1445],
  'Solapur': [75.9064, 17.6805],
  'Hubli-Dharwad': [75.1240, 15.3647],
  'Bareilly': [79.4304, 28.3670],
  'Moradabad': [78.7733, 28.8386],
  'Mysuru': [76.6394, 12.2958],
  'Mysore': [76.6394, 12.2958],
  'Tiruchirappalli': [78.7047, 10.7905],
  'Thiruvananthapuram': [76.9366, 8.5241],
  'Trivandrum': [76.9366, 8.5241],

  // Localities and special areas
  'Lal Kot': [77.1931, 28.5192],
  'Malviya Nagar': [77.2090, 28.5355],
  'M.P. Nagar': [77.4354, 23.2315],
};

export const COMPACT_STATE_NAMES = [
  // 28 States
  'andhrapradesh',
  'arunachalpradesh',
  'assam',
  'bihar',
  'chhattisgarh',
  'goa',
  'gujarat',
  'haryana',
  'himachalpradesh',
  'jharkhand',
  'karnataka',
  'kerala',
  'madhyapradesh',
  'maharashtra',
  'manipur',
  'meghalaya',
  'mizoram',
  'nagaland',
  'odisha',
  'punjab',
  'rajasthan',
  'sikkim',
  'tamilnadu',
  'telangana',
  'tripura',
  'uttarpradesh',
  'uttarakhand',
  'westbengal',

  // 8 Union Territories
  'andamanandnicobarislands',
  'chandigarh',
  'dadraandnagarhaveliandamananddiu',
  'damanandiu',
  'delhi',
  'jammuandkashmir',
  'ladakh',
  'lakshadweep',
  'puducherry',

  // Alternate spellings and old names
  'pondicherry',
  'orissa',
  'uttaranchal',
  'jammu&kashmir',
  'j&k',
];
